<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-31 11:22:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-31 11:22:07
-->
<template>
  <div class="brandTrade">
    <div class="brand-box" style="width: 1280px; margin: 0 auto">
      <div>
        <div class="brand-title">
          <span class="title" @click="$router.push('/')">首页</span> >
          <span class="title">交易公告</span>
        </div>
      </div>
      <div class="brand-list">
        <div
          class="brand-item"
          v-for="item in productData"
          :key="item.id"
          style="height:460px;"
        >
          <img :src="item.imageId ? item.imageId : defaultImg" />
          <div class="brand-item-content">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.productName"
              placement="top-start"
            >
              <span
                style="font-weight:800;width:270px;height:30px;overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;"
              >
                {{ item.productName }}</span
              >
            </el-tooltip>
            <p>发布者：{{ item.userName }}</p>
            <p>订单时间：{{ item.createTime }}</p>
            <p>交易状态：{{ item.status == 2 ? '交易成功' : '交易中' }}</p>
            <span class="price"
              >￥{{ item.money == 0 ? '面议' : item.money }}</span
            >
          </div>
        </div>
        <div class="result-item">
          <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../util/request'
const defaultImg = require('../assets/default.png')
import pagination from '../components/pagination.vue'
export default {
  name: 'brand-trade',
  components: {
    pagination,
  },
  data() {
    return {
      pageIndex: 1,
      num: 0,
      limit: 8,
      defaultImg,
      action: 1,
      productData: [],
      brandData: new Array(8).fill(''),
      brands: [],
      prices: [
        { label: '一万以下', value: '0:10000' },
        { label: '1-2万', value: '10000:20000' },
        { label: '2-5万', value: '20000:50000' },
        { label: '2-5万', value: '50000:999999999' },
      ],
    }
  },
  mounted() {
    let id = this.$route.query.id
    this.paraId = id
    console.log(id)
    this.queryProduct(id)
    this.queryBrand()
  },
  methods: {
    getNew(pageOffset) {
      this.pageIndex = pageOffset
      this.list = this.queryProduct()
    },
    //交易服务
    queryProduct(param) {
      request({
        url: '/api/client/common/order/list',
        params: { code: param, page: this.pageIndex, pageSize: this.limit },
      }).then((res) => {
        if (res.code == '200') {
          this.productData = res.data.records
          this.pageIndex = parseInt(res.data.current)
          this.num = parseInt(res.data.total)
          this.limit = parseInt(res.data.size)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    queryBrand() {
      request({
        url: '/api/client/common/select/dict/list',
        params: {
          key: 'trademarkclassify',
        },
      }).then((res) => {
        this.brands = res.data
      })
    },
  },
}
</script>

<style lang="less">
.result-item {
  width: 97%;
  background: #fff;
  text-align: center;
  margin-left: 8px;
  li {
    background: darkgrey;
  }
}

.brandTrade {
  .brand-title {
    height: 44px;
    display: flex;
    background: #fff;
    align-items: center;
    border: 1px solid #ccc;
    .title {
      font-size: 14px;
      font-weight: bold;
    }
    span {
      padding: 10px;
    }
    .active {
      color: #1890ff;
    }
  }
  .brand-box {
    width: 1280px;
    margin: 0 auto;

    .brand-search-box {
      display: flex;
      border: 1px solid #ccc;
    }
    .brand-left {
      width: 320px;
      padding: 20px 0 20px 20px;
      font-size: 16px;
      font-weight: bold;
      span {
        font-size: 12px;
        font-weight: 100;
        color: #999;
      }
    }
    .brand-right {
      display: flex;
      flex: 1;
      justify-content: start;
      align-items: center;
      flex-wrap: wrap;
      .trade-tags {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 110px;
        height: 50px;
      }
    }
  }

  .brand-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    margin: 20px 0;
    .brand-item {
      width: 310px;
      height: 400px;
      background: #fff;
      border: 2px solid #f2f2f2;
      border-bottom: 5px solid #f2f2f2;
      padding: 20px;
      margin-left: 13px;
      // margin-bottom: 15px;
      img {
        width: 100%;
        height: 240px;
        object-fit: contain;
      }
      .brand-item-content {
        margin-top: 15px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        .price {
          color: #ce1b14;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
}
.brand-list .brand-item:nth-child(1) {
  margin-left: 0px !important;
}

.brand-list .brand-item:nth-child(5) {
  margin-left: 0px !important;
}
</style>
